export default class PushMessage {
  public tags: string[] = []
  public title: string = ''
  public body: string = ''
  public custom1: string = ''
  public custom2: string = ''
  public custom3: string = ''
}
